import CompetitiveFax from "./CompetitiveFax";

export default CompetitiveFax;
